import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";
import pushDataLayer from "@ocm/services/dataLayer.js";

const $banderole = document.querySelector(".js-banderole");
const $banderoleCart = document.querySelector(".js-banderole-cart");

const modalId = "js-modal-banderole";
const modalCartId = "js-modal-banderole-cart";

OcmMessenger.subscribe(messengerPublicationTypes.ROUTE_CHANGE_MOUNTED_APPS, ({ data: { mountedApps } }) => {
	if (mountedApps.includes("mf-cart")) {
		_hide($banderole);
		_slideIn($banderoleCart);
		return;
	}
	_hide($banderoleCart);
	_slideIn($banderole);
});

function isCartPage() {
	return window.location.pathname.includes("/cart");
}

/*
interface show {
	content: Array< string | {
		text?: string
		bold?: boolean = false
		infoIcon?: false
		link?: string
	}>,
	modal: {
		headline: string
		text: string
	}
}

examples of usage for gtm in TUB-12463
*/

function show({ content, modal }) {
	$banderole.innerHTML = _getContentTemplate(content, modalId);
	_addModalContent(modal, modalId);

	const message = content.find((item) => item.text && !item.link)?.text ?? null;
	if (message) {
		document.querySelector("[data-track-banderole]")?.addEventListener("click", (e) => {
			e.preventDefault();
			pushDataLayer({
				event: "GAevent",
				event_category: "Banderole",
				event_action: message,
				event_label: window.recommendationData?.Recommendation?.pageData?.pagePath ?? null,
			});
			window.location.assign(e.currentTarget.href);
		});
	}

	if (isCartPage()) {
		_hide($banderole);
		return;
	}

	_slideIn($banderole);
}

function showCart({ content, modal }) {
	$banderoleCart.innerHTML = _getContentTemplate(content, modalCartId);
	_addModalContent(modal, modalCartId);
	_slideIn($banderoleCart);
}

function _slideIn(el) {
	if (el.hasChildNodes()) {
		el.style.display = "block";
		requestAnimationFrame(() => el.classList.add("slided-in"));
	}
}

function _hide(el) {
	el.style.display = "none";
	el.classList.remove("slided-in");
}

function _addModalContent(modal, id) {
	if (!modal) {
		return;
	}

	const $modal = document.getElementById(id);
	const $modalHeader = $modal.querySelector(".info-modal__header");
	const $modalBody = $modal.querySelector(".info-modal__body");

	$modalHeader.innerText = modal.headline;
	$modalBody.innerText = modal.text;
}

function _getContentTemplate(content, modalId) {
	return (
		content
			// eslint-disable-next-line complexity
			.map((contentItem) => {
				if (typeof contentItem === "string") {
					return contentItem;
				}

				let formattedText =
					contentItem.bold && contentItem.text
						? `<strong class="u-font-weight-semibold">${contentItem.text}</strong>`
						: contentItem.text || "";

				if (contentItem.link) {
					formattedText = `<a href="${contentItem.link}" class="c-banderole__link lg:ml-3" data-track-banderole>${formattedText}</a>`;
				}

				if (contentItem.infoIcon) {
					formattedText += `
						<svg
							onclick='document.getElementById("${modalId}").classList.add("is-visible");'
							class="c-banderole__icon svg-icon ml-2 u-pointer"
						>
							<use href="#icon-info"></use>
						</svg>
					`;
				}

				// infoIcon span wrapper is for smooth line breaks without infoIcon on a single line
				return `<span ${contentItem.infoIcon ? 'class="u-flex-inline u-no-wrap"' : ""}>${formattedText}</span>`;
			})
			.join("")
	);
}

export { show, showCart };
